import React, { useState } from "react";
import { Form, Select, Input, Card, Row, Col } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  VpnKeyTwoTone,
  AssessmentTwoTone,
  FilterHdrTwoTone,
  Filter1TwoTone,
  ViewWeekTwoTone,
} from "@material-ui/icons";

import CountrySelect from "../CountrySelect";
import SearchEngineSelect from "../SearchEngineSelect";
import { searchKeywords } from "../../store/actions/keywordActions";
import AddKeywords from "./AddKeywords/AddKeywords";
import TagsSelect from "./TagsSelect";
import AddReport from "../Reports/AddReport";
import { ManageCompetitorsModal } from "../Competitors/AddCompetitorModal/ManageCompetitorsModal";
import InputStyles from "../styles/InputStyles";
import LCButton from "../styles/LCButton";
import { CSVLink } from "react-csv";
import { useRouter } from "next/router";
import moment from "moment";

const SearchKeywords = (props) => {
  const dispatcher = useDispatch();
  const domain = useSelector((state) => state.domains.currentDomain);
  const currentDomain = useSelector((state) => state.domains.currentDomain);
  const keywordsObj = useSelector((state) => state.keywords);
  const [searchForm] = Form.useForm();
  const router = useRouter();
  const { keywords } = keywordsObj;
  const route = router.pathname;

  const [activeInput, setActiveInput] = useState("");

  const selectBefore = (
    <Form.Item
      name="rankOperator"
      style={{ padding: "0px", margin: "0px", height: "30px" }}
    >
      <Select defaultValue="eq">
        <Select.Option value="gt">&gt;</Select.Option>
        <Select.Option value="eq">=</Select.Option>
        <Select.Option value="lt">&lt;</Select.Option>
      </Select>
    </Form.Item>
  );

  const onFinish = (values) => {
    let search = { q: {} };
    if (values.keyword) {
      search.q.keyword = {
        regex: values.keyword,
        options: "i",
      };
    }
    if (values.searchEngine) {
      search.q.searchEngine = {
        in: values.searchEngine,
      };
    }
    if (values.country) {
      search.q.country = {
        in: values.country,
      };
    }
    if (values.tags) {
      search.q.tags = {
        in: values.tags,
      };
    }
    if (values.rank) {
      const rankOperator = values.rankOperator || "eq";
      search.q.rank = {
        [rankOperator]: parseInt(values.rank),
      };
    }
    if (values.rankStatus) {
      search.q.rankStatus = {
        in: values.rankStatus,
      };
    }
    if (values.impact) {
      search.q.impact = {
        in: values.impact,
      };
    }
    dispatcher(
      searchKeywords(domain._id, 1, search, keywordsObj.sort, keywordsObj.limit)
    );
  };

  const clearSearch = () => {
    searchForm.resetFields();
    dispatcher(
      searchKeywords(domain._id, 1, {}, keywordsObj.sort, keywordsObj.limit)
    );
  };

  const onFinishFailed = (values) => {
    console.log("Workable");
  };
  const data = keywords.map((keys) => {
    return {
      keywords: keys.keyword,
      Keywords_Ranking: keys.rank,
      searchEngine: keys.searchEngine,
      scrapedAt: keys.scrapedAt,
      country: keys.country,
      Competitor_Domain_Name: keys.competitors
        .map((competitor) => {
          return competitor.domainName;
        })
        .join(","),
    };
  });
  let domained = currentDomain && currentDomain.name.replaceAll(".", "_");
  const filename = `Competitor-Keywords-${domained}-${moment().format(
    "YYYY-MM-DD HH:mm:ss"
  )}`;
  const cardTitle = (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div>Keywords Overview</div>
      <div>
        {props.type === "target" ? (
          <ManageCompetitorsModal />
        ) : (
          <>
            {route !== "/competitors/keywords" && <AddReport />}
            <AddKeywords title="+Add Keywords" />
            {route === "/competitors/keywords" && (
              <CSVLink
                data={data}
                filename={`${filename}.csv`}
                className="btn btn-primary"
                target="_blank"
                style={{ display: "inline-block" }}
              >
                <LCButton type="secondary" addMargin as="button">
                  Download Report
                </LCButton>
              </CSVLink>
            )}
          </>
        )}
      </div>
    </div>
  );

  return (
    <InputStyles>
      <Card title={cardTitle}>
        <Row>
          <Col xs={24} sm={24} md={24}>
            <Form
              form={searchForm}
              layout="inline"
              name="basic"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
            >
              <Form.Item name="keyword" className="mb-1">
                <Input
                  placeholder=" Search By Keyword"
                  style={{ width: 200 }}
                  prefix={<VpnKeyTwoTone className="inputIcon" />}
                  className={`input ${
                    activeInput === "keyword" && "activeInput"
                  }`}
                  onFocus={() => {
                    setActiveInput("keyword");
                  }}
                  onBlur={() => setActiveInput("")}
                />
              </Form.Item>
              <Form.Item name="searchEngine" className="mb-1">
                <SearchEngineSelect classWidth="w-200" />
              </Form.Item>
              <Form.Item name="country" className="mb-1">
                <CountrySelect onlySearchEngine={true} classWidth="w-200" />
              </Form.Item>
              <Form.Item name="rank" className="mb-1">
                <Input
                  type="number"
                  addonBefore={selectBefore}
                  placeholder="Search By Rank"
                  min={1}
                  max={10}
                  style={{ width: 230 }}
                  prefix={<AssessmentTwoTone className="inputIcon" />}
                  className={`input ${activeInput === "rank" && "activeInput"}`}
                  onFocus={() => {
                    setActiveInput("rank");
                  }}
                  onBlur={() => setActiveInput("")}
                />
              </Form.Item>
              <TagsSelect
                placeholder="Search By Tags"
                formClass="search-by-tags"
              />
              <Form.Item name="rankStatus" className="mb-1">
                <Select
                  style={{ width: 200 }}
                  placeholder={
                    <>
                      <Filter1TwoTone className="mr-2 inputIcon" /> Search by
                      Status
                    </>
                  }
                  className={`select ${
                    activeInput === "rankStatus" && "activeSelect"
                  }`}
                  onFocus={() => {
                    setActiveInput("rankStatus");
                  }}
                  onBlur={() => setActiveInput("")}
                >
                  <Select.Option value="up">Up</Select.Option>
                  <Select.Option value="no_change">Stable</Select.Option>
                  <Select.Option value="down">Down</Select.Option>
                </Select>
              </Form.Item>
              <Form.Item name="impact" className="mb-1">
                <Select
                  style={{ width: 200 }}
                  placeholder={
                    <>
                      <FilterHdrTwoTone
                        className="mr-2"
                        // className='inputIcon'
                      />{" "}
                      Search by Impact
                    </>
                  }
                  className={`select ${
                    activeInput === "impact" && "activeSelect"
                  }`}
                  onFocus={() => {
                    setActiveInput("impact");
                  }}
                  onBlur={() => setActiveInput("")}
                >
                  <Select.Option value="up">Up</Select.Option>
                  <Select.Option value="down">Down</Select.Option>
                </Select>
              </Form.Item>
              <Form.Item className="mb-1">
                <LCButton type="secondary" as="button" htmlType="submit">
                  Search
                </LCButton>
              </Form.Item>
              <Form.Item>
                <LCButton type="primary" as="button" onClick={clearSearch}>
                  Clear
                </LCButton>
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </Card>
    </InputStyles>
  );
};

export default SearchKeywords;
